// Central brand configuration — RARE GROUP visual identity.
// Single source of truth: never hardcode logo paths or the brand name in pages.
export const BRAND = {
  name: "RARE GROUP",
  monogram: "RG",
  taglineAr: "ورد وهدايا فاخرة في قطر",
  taglineEn: "Luxury Flowers & Gifts in Qatar",
  logo: "/brand/logo.png?v=2",                       // square, white background
  logoTransparent: "/brand/logo-transparent.png?v=2", // black on transparent (header/menus)
  logoWhite: "/brand/logo-white.png?v=2",             // white version for dark surfaces
  icon: "/brand/icon-512.png",
  splash: "/brand/splash.png",
};
